import { connect } from 'react-redux'
import TripDetailLocation from '../../components/trips/trip-detail/location'
import * as actions from '../../state/actions/trips'
import * as userActions from '../../state/actions/users'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    //put props to be used here
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getManyStatusesById: async (tripId: string) => actions.getManyStatusesById(tripId)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripDetailLocation)



// WEBPACK FOOTER //
// ./src/containers/trips/location.ts